import { Wallet, WalletTransaction } from './wallet.models';

export const WALLET_ORDER_COL_NAME = 'orders';

export const WALLET_DEFAULT_PAGE_SIZE = 8;
export const WALLET_PROFILE_PAGE_SIZE = 3;

export function cleanedWallet(): Wallet {
  return {
    createdAt: null,
    updatedAt: null,
    userId: null,
    balance: 0,
    currency: 'EUR'
  };
}

/**
 * Returns true if the wallet transaction is linked to an order document.
 */
export function isWalletTransactionAnOrder(transaction: WalletTransaction): boolean {
  return transaction?.ref?.col === WALLET_ORDER_COL_NAME;
}
